<template>
<div>
  <preloader v-if="showPreloader"></preloader>
  <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismiss-count-down="countDownChanged"
    >
      {{allertMessage}}
  </b-alert>
  <div class="container">
    <base-button v-on:click='goHome' type="primary" size='md' class="my-4">Back</base-button>
  </div>
  <div v-if="!workdayIsStarted" class="container">
    <div class="row">
      <div class="offset-md-3 col-md-6">
        <div class="card card-profile shadow">
          <div class="card-body text-center">
            <h5 class="card-title text-center">Click to Start workday</h5>
            <div class="font-xl">
              <button @click="startWorkday" :disabled="disableStartWorkdayButton" class="pointer btn btn-primary"><span class="card-text">Start</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="workdayIsStarted" class="container">
    <div class="row">
      <div class="offset-md-3 col-md-6">
        <div class="card card-profile shadow">
          <div class="card-body text-center">
            <h5 class="card-title text-center">Click to End workday</h5>
            <div class="font-xl">
              <div class="row">
                <div class="col-md">
                  <form @submit.prevent class="needs-validation">
                    <base-button :disabled="disableEndWorkdayButton" v-on:click='endWorkday' type="primary">End workday</base-button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import alertMixin from '../mixins/alertMixin'
import timestampMixin from '../mixins/timestampMixin'
import errorStatusMixin from '../mixins/errorStatusMixin'
import stateUpdateMixin from '../mixins/stateUpdateMixin'
export default {
  data () {
    return {
      disableStartWorkdayButton: false,
      disableEndWorkdayButton: false,
      showPreloader: false,
      tests: [],
      photoType: null,
      passedDailyInspection: false
    }
  },
  methods: {
    startBreak () {},
    async endWorkday () {
      let self = this
      let time = this.getCurrentTime()
      self.disableEndWorkdayButton = true
      self.showPreloader = true
      self.$store.dispatch('endWorkday', { timeEnd: time, workdayId: this.$store.state.workday.id })
        .then(response => {
          if (response) {
            self.showPreloader = false
            self.disableEndWorkdayButton = false
            self.showAlert(2, 'Workday has been ended')
            self.$store.commit('changeWorkdayStatus', { isStarted: false })
            // self.resetState()
            self.stateUpload()
            self.goHomePage()
          }
        })
        .catch(err => {
          console.log(err)
          self.showPreloader = false
          self.disableEndWorkdayButton = false
          if (!self.errorStatusAvaible(err) && self.isOnline) return self.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
          if (self.isOnline) self.showAlert(5, err.response.data.result.message)
          if (self.isOffline) self.showAlert(3, 'You are offline now. You need to be online during sending this data')
        })
    },
    startWorkday () {
      let self = this
      self.disableStartWorkdayButton = true
      let time = self.getCurrentTime()
      self.showPreloader = true
      self.$store.dispatch('startWorkday', { timeStart: time })
        .then(response => {
          self.showPreloader = false
          self.disableStartWorkdayButton = false
          self.showAlert(2, 'Workday has been started')
          self.$store.commit('changeWorkdayStatus', { isStarted: true, workdayId: response.data.result.workday_id })
          self.stateUpload()
          self.goHomePage()
        })
        .catch(err => {
          console.log(err)
          self.showPreloader = false
          self.disableStartWorkdayButton = false
          if (!self.errorStatusAvaible(err) && self.isOnline) return self.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
          if (self.isOnline) self.showAlert(5, err.response.data.result.message)
          if (self.isOffline) self.showAlert(3, 'You are offline now. You need to be online during sending this data')
        })
    },
    goHomeWithDelay () {
      let self = this
      setTimeout(function () {
        self.goHomePage()
      }, 1500)
    },
    goHomePage () {
      this.$router.push('/')
    },
    update () {
      this.$db.tests.toArray().then(tests => {
        this.tests = tests
      })
    },
    takeSignature () {
      this.showSignature = true
      this.addClassToBody()
    },
    addClassToBody () {
      let body = document.body
      body.classList.add('overflowbody')
    },
    removeClassFromBody () {
      let body = document.body
      body.classList.remove('overflowbody')
    },
    add (value) {
      this.$db.tests.add({
        id: '_' + Math.random().toString(36).substr(2, 9),
        label: value
      }).then(() => this.update())
    },
    remove (test) {
      this.$db.tests.where('id').equals(test.id).delete().then(() => this.update())
    },
    goHome () {
      this.$router.push('/')
    }
  },
  mixins: [alertMixin, timestampMixin, stateUpdateMixin, errorStatusMixin],
  computed: {
    workdayIsStarted: function () {
      return this.$store.state.workday.isStarted
    }
  }
}
</script>
<style scoped>
 .font-xl {
   font-size: 1.2rem;
 }
 .custom-badge {
   line-height: 46px;
   padding-top: 0;
   padding-bottom: 0;
   font-size: 85%;
 }
 .pointer {
   cursor: pointer;
 }
 .form-control {
   background-position: center right calc(0.375em + 0.1875rem);
 }
 .danger {
   color: #f5365c;
 }
 .pause {
   color: #2dce89;
 }
</style>
